export function formReducer<T>(state: T, newState: T) {
  return {
    ...state,
    ...newState,
  }
}
